
import { Vue, Component, Prop } from 'vue-property-decorator';
import Draggable from 'vuedraggable';
import { IFileCheck } from '@/types/question.d';
import Box from './box.vue';

@Component({
  components: {
    Box,
    Draggable,
  },
})
export default class FirstStep extends Vue {
  @Prop() preFiles!: Array<IFileCheck>;

  private files: Array<IFileCheck> = [];

  mounted() {
    this.files = this.preFiles.sort((a: any, b: any) => a.sort - b.sort);
  }

  getSort(): Array<{ id: string, sort: number }> {
    return this.files.map((file: IFileCheck, index: number) => ({ id: file.pid || '', sort: index }));
  }
}
